import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, CloudIcon, BatteryIcon, ScaleIcon, WindIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    text: 'Inflamación abdominal frecuente',
    icon: FlameIcon,
    iconColor: 'text-orange-500',
    bgColor: 'bg-orange-50'
  }, {
    text: 'Digestión pesada',
    icon: CloudIcon,
    iconColor: 'text-sky-500',
    bgColor: 'bg-sky-50'
  }, {
    text: 'Baja energía',
    icon: BatteryIcon,
    iconColor: 'text-amber-500',
    bgColor: 'bg-amber-50'
  }, {
    text: 'Sensación de pesadez',
    icon: ScaleIcon,
    iconColor: 'text-violet-500',
    bgColor: 'bg-violet-50'
  }, {
    text: 'Dificultad para sentirse ligera otra vez',
    icon: WindIcon,
    iconColor: 'text-teal-500',
    bgColor: 'bg-teal-50'
  }];
  return <section className="py-24 bg-[#F2E8DA]/50 backdrop-blur-[2px]" data-id="element-194">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-195">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-196">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-black mb-6" data-id="element-197">
            A veces no es falta de esfuerzo.
            <br className="hidden md:block" data-id="element-198" /> Tu cuerpo solo necesita otro
            enfoque.
          </h2>
          <p className="text-lg text-black/80 font-semibold" data-id="element-199">
            Después de los 40, muchas mujeres comienzan a sentir:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-200">
          {problems.map((problem, index) => {
          const Icon = problem.icon;
          return <motion.div key={index} className={`bg-white rounded-2xl p-6 shadow-soft flex flex-col items-center text-center border border-beige ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-201">
                <div className={`w-14 h-14 rounded-full ${problem.bgColor} flex items-center justify-center mb-4 ${problem.iconColor}`} data-id="element-202">
                  <Icon className="w-6 h-6" strokeWidth={1.5} data-id="element-203" />
                </div>
                <p className="font-medium text-text-dark" data-id="element-204">{problem.text}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}